import { useContext } from "react";

import type { AuthModalsContext } from "./AuthModalsProvider";
import { authModalsProvider } from "./AuthModalsProvider";

export const useAuthModals = (): AuthModalsContext => {
  const data = useContext(authModalsProvider);

  if (!data) {
    throw new Error("useAuthModals must be used within a AuthModalsProvider");
  }

  return data;
};
